import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SpinnerService } from '../spinner.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit, AfterViewInit {
	

	loading = new BehaviorSubject<boolean>(null);
	loadingByOrderPageStep3 = new BehaviorSubject<boolean>(false);

	constructor(private spinnerService: SpinnerService) { }


	ngOnInit() {


		//this.spinnerService.isLoading.subscribe((v) => {

		//	if (v == 0) {
		//		this.loading.next(false);
		//	}
		//	else {
		//		this.loading.next(true);

		//	}
		//});
	}

	ngAfterViewInit(): void {

		this.spinnerService.isLoading.subscribe((v) => {

			if (v == 0) {
				this.loading.next(false);
			}
			else {
				this.loading.next(true);

			}
		});

		this.spinnerService.isLoadingByOrderPageStep3.subscribe((v) => {

			if (!v) {
				this.loadingByOrderPageStep3.next(false);
			}
			else {
				this.loadingByOrderPageStep3.next(true);

			}
		});
	}


}
